.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: var(--sp-2);
}

/* Два класса ради специфичности: одиночный .filterActive проигрывал глобальному
   .btn, и активная кнопка красила фон, не докрашивая текст. */
.filters .filterActive {
  background: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
  border-color: var(--btn-primary-bg);
}

.spacer {
  flex: 1;
}

.retention {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.error {
  margin: 0;
  color: var(--error);
  font-size: var(--fs-sm);
}

.empty {
  color: var(--text-3);
  font-size: var(--fs-sm);
  padding: var(--sp-6) 0;
  text-align: center;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  overflow: hidden;
}

.item + .item {
  border-top: 1px solid var(--border);
}

.row {
  display: flex;
  align-items: baseline;
  gap: var(--sp-4);
  width: 100%;
  padding: var(--sp-3) var(--sp-5);
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: var(--fs-sm);
}

.row:hover {
  background: var(--surface-2);
}

.time {
  color: var(--text-3);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

.level {
  font-size: var(--fs-xs);
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

/* --warn/--error здесь по назначению: это и есть предупреждения и ошибки. */
.levelWarn {
  color: var(--warn);
}

.levelError {
  color: var(--error);
}

.levelInfo {
  color: var(--flight);
}

.scope {
  color: var(--text-2);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

.message {
  color: var(--text);
  overflow-wrap: anywhere;
}

.details {
  padding: 0 var(--sp-5) var(--sp-5);
  border-top: 1px dashed var(--border);
  background: var(--surface-sunken);
}

.loading {
  margin: var(--sp-4) 0 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.sections {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding-top: var(--sp-4);
}

.sectionTitle {
  margin: 0 0 var(--sp-2);
  font-size: var(--fs-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-2);
}

.pre {
  margin: 0;
  padding: var(--sp-4);
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
  line-height: 1.5;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 400px;
  overflow-y: auto;
}

.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-5);
}

.pageInfo {
  font-size: var(--fs-sm);
  color: var(--text-2);
}
